import { getCuratorName, type OnchainSDK } from "@gearbox-protocol/sdk/onchain";
import type { FC } from "react";
import { useMemo } from "react";
import type { Address } from "viem";
import { AddressSelector } from "./AddressSelector";

export interface CuratorSelectorProps {
  sdk: OnchainSDK;
  value: Address | undefined;
  onChange: (curator: Address | undefined) => void;
}

export const CuratorSelector: FC<CuratorSelectorProps> = props => {
  const { sdk, value, onChange } = props;

  const curators = useMemo(
    () =>
      sdk.marketRegister.marketConfigurators.map(configurator => ({
        address: configurator.address,
        name: getCuratorName(configurator.address, sdk.networkType),
      })),
    [sdk],
  );

  return (
    <>
      <h4>Curators</h4>
      <AddressSelector items={curators} value={value} onChange={onChange} />
    </>
  );
};
